module.exports = __webpack_public_path__ + "img/casimir-crystal-lv2.ca80989a.png";